import React, { useState } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router";
import axios from "axios";
import { endSession } from "../../utils/sessionUtils";
import PersonIcon from "@mui/icons-material/Person";

function Navbar() {
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const logout = () => {
    endSession();
    // axios.delete(`${process.env.REACT_APP_BASE_URL}/user/auth`).then((res) => {
    //   navigate("/login");
    // });
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  if (localStorage.session) {
    var user = JSON.parse(localStorage.session);
  }

  return (
    <div className="navbar">
      <Grid container rowSpacing={4} columnSpacing={{ md: 2 }}>
        <Grid item sm={2}>
          <div className="logo">
            <img src="/assets/logo.png" alt="" />
          </div>
        </Grid>
        <Grid item sm={10}>
          <div className="navbar-widgets">
            <div className="searchbar">
              {/* <img src="/assets/icons/search.svg" alt="" />
              <input type="text" placeholder="Search agent or client" /> */}
            </div>
            <div onClick={() => {}} className="notifications">
              {/* <img src="/assets/icons/bell.svg" alt="" /> */}
              {/* <div className="circle">
                <span className="notifications-number">5</span>
              </div> */}
            </div>            <div className="user">
              <div className="profile-pic" style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                backgroundColor: '#95B2C5',
                borderRadius: '50%',
                width: '40px',
                height: '40px'
              }}>
                <PersonIcon sx={{ fontSize: 24, color: '#021C2D' }} />
              </div>
              <span className="name">
                <div>
                  {user?.fullName || "-"} <br />
                  <b
                    style={{
                      fontSize: "10px",
                      textAlign: "right",
                      display: "block",
                    }}
                  >
                    {user?.role || "-"}
                  </b>
                </div>
              </span>
              <img
                onClick={toggleDropdown}
                className="chevron"
                src="/assets/icons/chevron-down.svg"
                alt=""
              />
            </div>
            {isDropdownOpen && (
              <div className="dropdown-menu">
                <ul>
                  <li onClick={() => navigate("/edit-profile")}>
                    Edit profile
                  </li>
                  <hr />
                  <li onClick={logout}>Log out</li>
                </ul>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default Navbar;
